// @flow
import React from "react"
import { Text } from "componentsStyled/Typography/Texts"

const IntroMessage = () => (
  <Text>
    <p>
      <b>Try your favourite products with Awayco.</b>
    </p>
    <p>
      To get started, simply browse below, select the location you want to
      collect from, and book. You will be asked to create an account, but
      don’t worry - you only pay for what you use and your data is secure.
    </p>
  </Text>
)

export default IntroMessage



// WEBPACK FOOTER //
// ./src/components/IntroMessage/index.js